<template>
  <b-modal v-model="modalVisible" centered hideHeaderClose hide-footer hide-header modal-class="add-to-cart-modal" size="lg">
    <template #modal-header>
      
    </template>
    <template #default="{ close }">
      <div>
        <div class="row px-lg-4 py-lg-3 mt-4 mt-lg-0">
          <div class="col-12 col-lg-4 mb-3 mb-lg-0">
            <div class="position-relative">
              <div class="square-img">
                <img :src="mainImg" />
              </div>
            </div>
          </div>

          <div class="col">
            <div class="product-info">
              <label>{{ product.name }}</label>
              <p class="p-desc" v-html="shortDesc"></p>
              <p class="p-price">NT ${{ productPrice }}<span v-if="hasSale" class="p-sale"> NT ${{ product.originPrice }} </span></p>
              <NumberInput class="mb-3" v-model="buyAmount"></NumberInput>
              <SimpleButton class="w-100 mb-3 mb-lg-0" @click="addToCartClicked">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5 15.5L9.5 12" stroke="white" stroke-linecap="round"/>
                  <path d="M8.5 4.5L6.5 7.5M15.5 4.5L17.5 7.5" stroke="white" stroke-linecap="round"/>
                  <path d="M13.5 15.5L14.5 12" stroke="white" stroke-linecap="round"/>
                  <path d="M4.5 9.5V9.5C5.08429 9.5 5.59018 9.90581 5.71693 10.4762L6.80394 15.3677C7.13763 16.8694 7.30448 17.6202 7.85289 18.0601C8.4013 18.5 9.17043 18.5 10.7087 18.5H13.2913C14.8296 18.5 15.5987 18.5 16.1471 18.0601C16.6955 17.6202 16.8624 16.8694 17.1961 15.3677L18.2831 10.4762C18.4098 9.90581 18.9157 9.5 19.5 9.5V9.5" stroke="white" stroke-linecap="round"/>
                  <path d="M19.5 9.5H4.5C3.94772 9.5 3.5 9.05228 3.5 8.5C3.5 7.94772 3.94772 7.5 4.5 7.5H19.5C20.0523 7.5 20.5 7.94772 20.5 8.5C20.5 9.05228 20.0523 9.5 19.5 9.5Z" stroke="white" stroke-linecap="round"/>
                </svg>
                加到購物車
              </SimpleButton>
            </div>
          </div>
        </div>
        <button class="cancel-btn" @click="close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#333333"/>
          </svg>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import NumberInput from '@/components/NumberInput.vue';
import SimpleButton from '@/components/buttons/SimpleButton';
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
  name: 'AddToCartModal',
  data() {
    return {
      buyAmount: 1,
    };
  },
  components: {
    NumberInput,
    SimpleButton,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
  },
  computed: {

    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    mainImg() {
      if (this.product.imgs.length > 0) {
        return this.product.imgs[0];
      }
      return '';
    },
    shortDesc() {
      return this.product.shortDesc.replace(/\s/g, '<br/>');
    },
    productPrice() {
      if (this.product.earlyPrice > 0 && moment().isSameOrBefore(moment(this.product.earlyDateLimit))) {
        return this.product.earlyPrice;
      }
      if (this.product.sellPrice > 0) {
        return this.product.sellPrice;
      }
      return this.product.originPrice;
    },
    hasSale() {
      if (this.product.earlyPrice > 0 && moment().isSameOrBefore(moment(this.product.earlyDateLimit))) {
        return true;
      }
      if (this.product.sellPrice > 0 && this.product.originPrice > 0 && this.product.originPrice > this.product.sellPrice) {
        return true;
      }
      return false;
    },
  },
  watch: {
  },
  async mounted() {
  },
  methods: {
    ...mapActions('cart', ['addItemToCart']),
    addToCartClicked() {
      this.addItemToCart({
        product: this.product,
        amount: this.buyAmount,
      });
      this.$bvModal.msgBoxOk('已加入購物車！', {
        title: '',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: '確認',
        footerClass: 'justify-content-center',
        hideHeaderClose: true,
        centered: true
      }).then(() => {
        
        this.modalVisible = false;
      });
      
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/main.scss';
.add-to-cart-modal {
  .square-img {
    width: 100%;
    padding-top: 100%;
    border-radius: 1rem;
    overflow: hidden;
    >img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      object-fit: cover;
    }
  }

  .product-info {
    label {
      font-weight: 600;
      font-size: 1.2rem;
      margin-bottom: 0rem;
    }
    .p-desc {
      font-size: .9rem;
    }
    .p-price {
      font-weight: 600;
      font-size: 1rem;
      margin-bottom: .5rem;
      .p-sale {
        color: #f44;
        text-decoration: line-through;
      }
    }
  }

  .cancel-btn {
    position: absolute;
    right: .5rem;
    top: .5rem;
    background-color: transparent;
    border: none;
  }
}
</style>
